import PropTypes from 'prop-types'
import styled from 'styled-components'

import { PB40T } from '../../colors'
import { Skeleton as SkeletonComponent } from '../../loading/skeleton'

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`
const Head = styled.thead``
const Cell = styled.td`
  height: 65px;
  padding: 0 8px;
`
const Row = styled.tr`
  border-top: 1px solid ${PB40T};
`
const HeadRow = styled.tr``
const Body = styled.tbody``
const Skeleton = ({ columns }) => {
  const rows = 10

  return (
    <Table>
      <Head>
        <HeadRow>
          {Array(columns)
            .fill()
            .map((headRow, index) => (
              <Cell key={index}>
                <SkeletonComponent width={'30%'} />
              </Cell>
            ))}
        </HeadRow>
      </Head>
      <Body>
        {Array(rows)
          .fill()
          .map((bodyRow, rowIndex) => (
            <Row key={rowIndex}>
              {Array(columns)
                .fill()
                .map((cellItem, cellIndex) => (
                  <Cell key={`${rowIndex}-${cellIndex}`}>
                    <SkeletonComponent width={'80%'} />
                  </Cell>
                ))}
            </Row>
          ))}
      </Body>
    </Table>
  )
}

Skeleton.propTypes = {
  columns: PropTypes.number.isRequired
}

export { Skeleton }
